import { Button, Callout } from "@octopusdeploy/design-system-components";
import type { ActivityLogElement } from "@octopusdeploy/octopus-server-client";
import { links } from "@octopusdeploy/portal-routes";
import { noOp } from "@octopusdeploy/utilities";
import type { FC } from "react";
import { Section } from "~/components/Section/Section";
import TaskLogLines from "~/components/TaskLogLines/TaskLogLines";
import HALogWarning from "./HALogWarning";
interface ServerLogsProps {
    logs: ActivityLogElement[];
    isHA: boolean;
}
const ServerLogs: FC<ServerLogsProps> = (props) => {
    const logs = props.logs;
    return (<div>
            <Section sectionHeader="Server Logs">
                <p>The entries below are the most recent warning and error-level events recorded on this Octopus Server node in this session.</p>
                <HALogWarning isHA={props.isHA}/>
                {logs && logs.length === 0 && (<Callout type={"information"} title={"No events found"}>
                        No warning or error-level events have been collected in this session.
                    </Callout>)}
            </Section>
            <Section>
                <TaskLogLines lines={logs} showTimestamps={true} onFetchRange={noOp} isFetchDisabled={true}/>
                <Button label="View detailed log" href={links.diagnosticServerLogsPage.generateUrl()} importance="quiet"/>
            </Section>
        </div>);
};
ServerLogs.displayName = "ServerLogs";
export default ServerLogs;
